export default __webpack_public_path__ + "static/media/search-icon.cb53eece.svg";